import React, { FC } from 'react';
import { useLiquidityWizardState } from '@app/screens/liquidity/LiquidityWizard/state';
import { IDerivedLiquidityByIchiInfo } from '@app/state/liquidityByIchiStore';
import { LiquidityWizardMinInfo } from '@app/screens/liquidity/LiquidityWizard/hooks/useDerivedMintInfo';
import { IDerivedMintInfoWithProvider } from '@app/state/mintStore';
import { StakeToNitroView } from '@app/screens/liquidity/LiquidityWizard/components/CompleteStep/components/StakeToNitroView';

interface Props {
  mintInfo: LiquidityWizardMinInfo;
  ichiMintInfo: IDerivedLiquidityByIchiInfo;
  steerMintInfo: IDerivedMintInfoWithProvider;
}

export const AddToNitroView: FC<Props> = ({
  mintInfo,
  ichiMintInfo,
  steerMintInfo
}) => {
  const { strategy, mode, provider, tokenId } = useLiquidityWizardState();

  if (
    provider === 'steer' &&
    steerMintInfo.selectedVault &&
    steerMintInfo.nftPoolAddress
  ) {
    return (
      <StakeToNitroView
        vault={steerMintInfo.selectedVault}
        tokenId={tokenId}
        deposit=""
        nftPoolAddress={steerMintInfo.nftPoolAddress}
        nitroPoolId={steerMintInfo.nitroDetails?.id}
      />
    );
  }

  if (
    provider === 'ichi' &&
    ichiMintInfo.vault &&
    ichiMintInfo.nftPoolAddress
  ) {
    return (
      <StakeToNitroView
        vault={ichiMintInfo.vault}
        tokenId={''}
        deposit=""
        nftPoolAddress={ichiMintInfo.nftPoolAddress}
        nitroPoolId={ichiMintInfo.nitroDetails?.id}
      />
    );
  }

  return null;
};
